import React from 'react'
import { BogoTermsLink } from '@mc/bogo'
import { Trans } from '@mc/i18n'
import { PrivacyLink, TermsLink } from '../../links'

export const BogoLegal = ({ className = '' }: { className?: string }) => (
  <p className={className}>
    <Trans i18nKey='emailCapture.bogo' ns='@mc/legal'>
      <BogoTermsLink className='mc-text--capitalize' />
      <TermsLink />
      <PrivacyLink />
    </Trans>
  </p>
)
